module.exports = __webpack_public_path__ + "img/cross_v1.3d90c948.svg";